import * as React from 'react'

import { inject, observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import ProjectDateStore from '~/client/src/shared/stores/ui/ProjectDate.store'

interface IProps {
  selectedDayNumbers: number[]
  onClick: (dayNumber: number) => void

  className?: string

  projectDateStore?: ProjectDateStore
}

@inject('projectDateStore')
@observer
export default class WeekdaysSelector extends React.Component<IProps> {
  public render() {
    const { selectedDayNumbers, onClick, className } = this.props

    return (
      <div
        className={classList({
          'tw:flex tw:items-center tw:grow-0': true,
          [className]: !!className,
        })}
      >
        {this.weekdaysShortNamesList.map((day, index) => {
          const dayNumber = ++index
          const isSelected = selectedDayNumbers?.includes(dayNumber)
          const isNonWorkingDay = !this.isWorkingDay(dayNumber)

          return (
            <div
              key={dayNumber}
              className={classList({
                'tw:mx-[5px] tw:size-6 tw:rounded-[60%] tw:flex tw:items-center tw:justify-center tw:text-label-md tw:font-semibold tw:cursor-pointer': true,
                'tw:text-primary-foreground tw:bg-primary':
                  isSelected && !isNonWorkingDay,
                'tw:text-destructive-foreground tw:bg-destructive':
                  isSelected && isNonWorkingDay,
                'tw:bg-muted tw:border tw:border-solid tw:border-border':
                  !isSelected,
                'tw:text-foreground': !isSelected && !isNonWorkingDay,
                'tw:text-destructive': !isSelected && isNonWorkingDay,
                'tw:opacity-70': isNonWorkingDay,
              })}
              onClick={onClick.bind(null, dayNumber)}
            >
              {day}
            </div>
          )
        })}
      </div>
    )
  }

  private isWorkingDay = (dayNumber: number): boolean => {
    return this.props.projectDateStore.workingDaysMap[dayNumber]
  }

  private get projectDateStore(): ProjectDateStore {
    return this.props.projectDateStore
  }

  private get weekdaysShortNamesList(): string[] {
    return this.projectDateStore.weekdaysShortNamesList
  }
}
